import { render } from "./order-summary.component.vue?vue&type=template&id=40f5f437&ts=true"
import script from "./order-summary.component.vue?vue&type=script&lang=ts"
export * from "./order-summary.component.vue?vue&type=script&lang=ts"

import "./order-summary.component.vue?vue&type=style&index=0&id=40f5f437&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__